
<mat-dialog-content [innerHTML]="data" class="mat-typography">
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button class="activebtn my-2" color="primary" (click)="vlidateCgu()" mat-dialog-close>J'accepte l'ensemble des conditions générales de vente et d'utilisation</button>
</mat-dialog-actions>

